/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { groupBy } from 'lodash';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  mcoClaimsManufacturerTableGrid,
  mcoClaimsNDCTableGrid,
  mcoClaimsTotalTableGrid,
} from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PaginationBox from './PaginationBox';
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  PAGINATION_EMPTY_ERR,
  PAGINATION_NEGATIVE_ERR,
  PAGINATION_OVER_TOTAL_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';

const DisplayMCOClaims = () => {
  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [searchResultList, setSearchResultList] = React.useState([]);
  const [searchResultList1, setSearchResultList1] = React.useState([]);
  const [errorMessages, setErrorMessages] = React.useState([]);

  // use Selector function

  const manufactureName = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.allManufacturer
  );

  const manufactureID = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.manufactureWithIds
  );

  const isLoading = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.isLoading
  );
  const {
    displayObj: {
      setRebateProgram: rebateProgramValue,
      quarter: getQuarter,
      rebateProgrameName,
      rebateProgram: getRebateProgramList,
      selectedOption: getSelectedOptionList,
      uraType: getUraType,
      searchResult: getSearchResult,
      isMfgChecked,
    },
  } = useSelector((state) => state?.sharedState?.MCOClaimsReducer);
  const rebateProgramNameValue = `${
    rebateProgrameName?.rebateProgramCd || ''
  } - ${rebateProgrameName?.shortDescr || ''}`;

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // MAPPING quarter option
  const nameMapping = {
    ndc: 'NDC',
    mfg: 'Manufacturer',
    tot: 'Totals',
    inv: 'Invoice',
    cur: 'Current',
  };
  const paginationLength = getSelectedOptionList === manufacturer;
  const [count, setCount] = React.useState(1);
  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(paginationLength).keys(),
  ]);
  /*
    This function handle the side effect of next previios of pagination box
  */
  const handleClick = (type, value) => {
    dispatch(clearReduxForFilterAndSort('/display_mco_claims'));

    if (type === 'next') {
      setCount(count + 1);
    }

    if (type === 'previous') {
      setCount(count - 1);
    }

    if (type === 'change') {
      if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
      else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        setCount(value);
      }
    }
  };

  /*
       this function handle the vlue like text in input box
    */
  const handleBlur = (value) => {
    dispatch(clearReduxForFilterAndSort('/display_mco_claims'));

    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    //   setCount(0);
    //   setTimeout(() => {
    //     value < 1 ? setCount(1) : setCount(paginationArray.length);
    //   }, 20);
    if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
    else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray.length)
      setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      setCount(parseInt(value));
    }
  };

  // mfg grid api
  let manufacturer = manufactureID;

  // to add total row for particular mfg
  const addTotalRow = (data) => {
    const dataWithTotal = [];
    for (const key in data) {
      const oneMfgData = data[key];
      const totalRow = {};
      for (let i = 0; i < oneMfgData.length; i += 1) {
        const mod = { ...oneMfgData[i] };
        if (i !== 0) {
          mod.firstColumn = '';
          mod.name = '';
        }
        dataWithTotal.push(mod);
        if (totalRow.groupHeader) {
          totalRow.invoicedAmount += parseFloat(
            oneMfgData[i].invoicedAmount || 0
          );
          totalRow.percent += parseFloat(oneMfgData[i].percent || 0);
          totalRow.paidAmount += parseFloat(oneMfgData[i].paidAmount || 0);
        } else {
          totalRow.groupHeader = 'Total';
          totalRow.invoicedAmount = parseFloat(
            oneMfgData[i].invoicedAmount || 0
          );
          totalRow.percent = parseFloat(oneMfgData[i].percent || 0);
          totalRow.paidAmount = parseFloat(oneMfgData[i].paidAmount || 0);
        }
      }
      if (getSelectedOptionList === 'mfg') {
        totalRow.percent = parseFloat(100);
      }
      dataWithTotal.push(totalRow);
    }
    return dataWithTotal;
  };
  const addTotalRowOne = (data) => {
    const dataWithTotal = [];
    for (const key in data) {
      const oneMfgData = data[key];
      const totalRow = {};
      for (let i = 0; i < oneMfgData.length; i += 1) {
        const mod = { ...oneMfgData[i] };
        if (i !== 0) {
          mod.firstColumn = '';
        }
        dataWithTotal.push(mod);
        if (totalRow.groupHeader) {
          totalRow.invoicedAmount += parseFloat(
            oneMfgData[i].invoicedAmount || 0
          );
          totalRow.percent += parseFloat(oneMfgData[i].percent || 0);
          totalRow.paidAmount += parseFloat(oneMfgData[i].paidAmount || 0);
        } else {
          totalRow.groupHeader = 'Total';
          totalRow.invoicedAmount = parseFloat(
            oneMfgData[i].invoicedAmount || 0
          );
          totalRow.percent = parseFloat(oneMfgData[i].percent || 0);
          totalRow.paidAmount = parseFloat(oneMfgData[i].paidAmount || 0);
        }
      }
  
      if (getSelectedOptionList === 'tot') {
        totalRow.percent = parseFloat(100);
      }
      dataWithTotal.push(totalRow);
    }
    return dataWithTotal;
  };
  const [tableCount, setTableCount] = useState(0);

  // SET data from MCO
  React.useEffect(() => {
    const processData = () => {
      let data = getSearchResult;
      if (getSelectedOptionList === 'mfg') {
        const groupedData = groupBy(data, 'firstColumn');
        data = addTotalRow(groupedData);
      } else if (getSelectedOptionList === 'ndc') {
        const filteredData = data?.filter((item) => item.firstColumn !== null);
        const groupedData = groupBy(data, 'firstColumn');
        data = addTotalRow(groupedData);
      }
      const newData = data?.map((item) => {
        const newPercent = item?.percent;
        const newPaidAmt = item?.paidAmount;
        const newAmt = item?.invoicedAmount;

        return {
          ...item,
          invoicedAmount: parseFloat(newAmt).toFixed(2),
          percent: parseFloat(newPercent).toFixed(2),
          paidAmount: parseFloat(newPaidAmt).toFixed(2),
          ura: item?.ura?.toFixed(4),
        };
      });
      setSearchResultList(newData);
    };
    const processData1 = () => {
      let data = getSearchResult;
      if (getSelectedOptionList === 'tot') {
        const groupedData = groupBy(data, 'firstColumn');
        data = addTotalRowOne(groupedData);
      }
    
      const newData = data?.map((item) => {
        const newPercent = item?.percent;
        const newPaidAmt = item?.paidAmount;
        const newAmt = item?.invoicedAmount;

        return {
          ...item,
          invoicedAmount: parseFloat(newAmt).toFixed(2),
          percent: parseFloat(newPercent).toFixed(2),
          paidAmount: parseFloat(newPaidAmt).toFixed(2),
        };
      });
      setSearchResultList1(newData);
    };

    processData();
    processData1();

  }, [getSearchResult, getSelectedOptionList]);
 const onGridReady = useCallback((params) => {
    setTableCount(params.api.getDisplayedRowCount());
  }, []);
  // pdf header
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';
  let fourthInfo = '';
  let fifthInfo = '';

  firstInfo = `Manufacturer: ${manufactureName || manufactureID}`;
  secondInfo = `Rebate Program:${rebateProgramNameValue}`;
  thirdInfo = `Quarter:${getQuarter}`;
  fourthInfo = `Report Detail Level: ${nameMapping[getSelectedOptionList]}`;
  fifthInfo = `URA Type:${nameMapping[getUraType]}`;
const Totalcount = searchResultList?.filter(
  (row) => row.groupHeader !== "Total"
).length
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1="Detail Reports"
        parent2="Display MCO Claims Rpt"
      />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-0">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-5">
                      <div className="col-12">
                        <div className="float-right">
                          <PaginationBox
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program "
                          id="Rebate Program"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgramNameValue}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Quarter "
                          id="Quarter"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={getQuarter}
                        />
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="URA Type"
                          id="URA Type"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={nameMapping[getUraType]}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Report Detail Level "
                          id="Report Detail Level"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={nameMapping[getSelectedOptionList]}
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Manufacturer"
                          id="Manufacturer"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={manufactureName}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="clearfix">
          {getSelectedOptionList === 'ndc' && (
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner"
            >
                <TableGrid
                onGridReady={onGridReady}
                ref={gridRef}
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={
                  fullScreenView ? '70vh' : commonConstant.viewPortHeight_355
                }
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                isScrollOn
                noGlobalSort
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;
                    if (name && name.length > 25) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                rowData={searchResultList?.map((item) => {
                  return {
                    ...item,
                    invoicedAmount: item.invoicedAmount
                      ? parseFloat(item.invoicedAmount)?.toFixed(2)
                      : '0.00',
                    paidAmount: item.paidAmount
                      ? parseFloat(item.paidAmount).toFixed(2)
                      : '0.00',
                    units:
                      item.units === undefined
                        ? ''
                        : parseFloat(item.units)?.toFixed(4),
                    percent: item.percent
                      ? parseFloat(item.percent)?.toFixed(2)
                      : '0.00',
                  };
                })}
                hideTotalCount={true}
                columnDefs={mcoClaimsNDCTableGrid}
                exportFile
                animateRows
                sideBar={false}
                fileName="MCOCLAIMS"
                reportName="MCO Percentage Report - NDC level"
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                hideColumnsInPdf
                // handleViewHistory
                info={{
                  firstInfo,
                  secondInfo,
                  fifthInfo,
                  thirdInfo,
                  fourthInfo,
                }}
              />
               <p className="total-results" tabIndex="0">
              Total Results: <b>{Totalcount?.toLocaleString('en-US')}</b>
              </p>
            </div>
          )}
          {getSelectedOptionList === 'mfg' && (
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner"
            >
                <TableGrid
                onGridReady={onGridReady}
                ref={gridRef}
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={
                  fullScreenView ? '70vh' : commonConstant.viewPortHeight_355
                }
                rowData={searchResultList?.map((item) => {
                  return {
                    ...item,
                    invoicedAmount: item.invoicedAmount
                      ? parseFloat(item.invoicedAmount).toFixed(2)
                      : '0.00',
                    paidAmount: item.paidAmount
                      ? parseFloat(item.paidAmount).toFixed(2)
                      : '0.00',
                    percent:
                      item.groupHeader === 'Total'
                        ? item?.percent
                        : parseFloat(
                            (parseFloat(item?.invoicedAmount || 0) /
                              parseFloat(item?.totalInvoicedAmount || 0)) *
                              100
                          ).toFixed(2),
                  };
                })}
                isScrollOn
                noGlobalSort
                defaultColWidth={250}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;
                    if (name && name.length > 25) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                columnDefs={mcoClaimsManufacturerTableGrid}
                exportFile
                animateRows
                sideBar={false}
                fileName="MCOCLAIMS"
                reportName="MCO Percentage Report - Manufacturer level"
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                hideTotalCount={true}
                info={{
                  firstInfo,
                  secondInfo,
                  fifthInfo,
                  thirdInfo,
                  fourthInfo,
                }}
              />
               <p className="total-results" tabIndex="0">
              Total Results: <b>{Totalcount?.toLocaleString('en-US')}</b>
              </p>
            </div>
          )}

          {getSelectedOptionList === 'tot' && (
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner"
            >
              <TableGrid
                onGridReady={onGridReady}
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                hideTotalCount={true}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={
                  fullScreenView ? '70vh' : commonConstant.viewPortHeight_355
                }
                noGlobalSort
                rowData={searchResultList1?.map((item) => {
                  return {
                    ...item,
                    invoicedAmount: item.invoicedAmount
                      ? parseFloat(item.invoicedAmount).toFixed(2)
                      : '0.00',
                    paidAmount: item.paidAmount
                      ? parseFloat(item.paidAmount).toFixed(2)
                      : '0.00',
                    percent:
                      item.groupHeader === 'Total'
                        ? item?.percent
                        : parseFloat(
                            (parseFloat(item?.invoicedAmount || 0) /
                              parseFloat(item?.totalInvoicedAmount || 0)) *
                              100
                          ).toFixed(2),
                  };
                })}
                columnDefs={mcoClaimsTotalTableGrid}
                exportFile
                animateRows
                sideBar={false}
                fileName="MCOCLAIMS"
                reportName="MCO Percentage Report - Totals level"
                singleClickEdit
                isScrollOn
                defaultColWidth={250}
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                hideColumnsInPdf
                // handleViewHistory
                info={{
                  firstInfo,
                  secondInfo,
                  fifthInfo,
                  thirdInfo,
                  fourthInfo,
                }}
              />
               <p className="total-results" tabIndex="0">
              Total Results: <b>{tableCount-1?.toLocaleString('en-US')}</b>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DisplayMCOClaims;
